// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2zXkK","info":"Note_info__FX_8n","note":"Note_note__2wrdY","actions":"Note_actions__2IE0t"};